import { render, staticRenderFns } from "./InputsShadowTypeMask.vue?vue&type=template&id=9f4ee880"
import script from "./InputsShadowTypeMask.vue?vue&type=script&lang=js"
export * from "./InputsShadowTypeMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f4ee880')) {
      api.createRecord('9f4ee880', component.options)
    } else {
      api.reload('9f4ee880', component.options)
    }
    module.hot.accept("./InputsShadowTypeMask.vue?vue&type=template&id=9f4ee880", function () {
      api.rerender('9f4ee880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/mask-settings-components/InputsShadowTypeMask.vue"
export default component.exports